import { render, staticRenderFns } from "./ReportTemplateSettings.vue?vue&type=template&id=061a5a0c&scoped=true"
import script from "./ReportTemplateSettings.vue?vue&type=script&lang=js"
export * from "./ReportTemplateSettings.vue?vue&type=script&lang=js"
import style0 from "./ReportTemplateSettings.vue?vue&type=style&index=0&id=061a5a0c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "061a5a0c",
  null
  
)

export default component.exports